"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const React = __importStar(require("react"));
const react_emotion_1 = __importDefault(require("react-emotion"));
const pageHeader = ({ title, subtitle, description, rightJustifiedDescription, buttons, rawButtons, extraContent, tag = 'h1', }) => {
    const InlineTitle = react_emotion_1.default(tag) `
    display: inline-block;
  `;
    if (buttons && rawButtons) {
        console.info("You should use either the 'buttons' or 'rawButtons' parameter, not both");
    }
    return (React.createElement("div", { className: tag === 'h1' ? 'awsui-util-mb-m awsui-util-mt-xs' : undefined },
        React.createElement("div", { className: tag === 'h1' ? 'awsui-util-action-stripe-large ' : 'awsui-util-action-stripe' },
            React.createElement("div", { className: "awsui-util-action-stripe-title" },
                React.createElement("span", null,
                    React.createElement(InlineTitle, null, title),
                    extraContent,
                    subtitle && React.createElement("div", null, subtitle),
                    description && (React.createElement("div", { className: "awsui-util-container-header-description" }, description)))),
            React.createElement("div", { className: "awsui-util-action-stripe-group awsui-util-pv-n" },
                buttons &&
                    buttons
                        .filter((b) => b)
                        .map((b) => b)
                        .map(({ items, id, href, text, disabled, loading, icon, variant = 'normal', onItemClick, onClick, }, key) => {
                        return !items ? (React.createElement(polaris_1.Button, { id: id, href: href, text: text, disabled: disabled || false, loading: loading || false, icon: icon, variant: variant, key: key, onClick: onClick })) : (React.createElement(polaris_1.ButtonDropdown, { id: id, text: text, disabled: disabled || false, loading: loading || false, items: items, key: key, onItemClick: onItemClick }));
                    }),
                rawButtons)),
        rightJustifiedDescription && (React.createElement("div", { id: "container-right-justified-description", className: "awsui-util-container-header-description", css: "text-align:right;" }, rightJustifiedDescription))));
};
pageHeader.displayName = 'PageHeader';
exports.default = pageHeader;
//# sourceMappingURL=PageHeader.js.map